// URL 检查的状态类型
export const URL_STATUS = {
    ACCESSIBLE: 'accessible',
    REDIRECT: 'redirect',
    NOT_ACCESSIBLE: 'not_accessible'
};

// 检查单个 URL
export const checkUrl = async (url) => {
    try {
        const response = await fetch(url, {
            method: 'HEAD',
            redirect: 'follow'
        });
        
        return {
            isAccessible: true,
            isRedirect: response.status >= 300 && response.status < 400,
            status: response.status
        };
        
    } catch (error) {
        const isCorsError = error.name === 'TypeError' && 
            (error.message.includes('CORS') || error.message.includes('Failed to fetch'));
        
        return {
            isAccessible: isCorsError,
            isRedirect: false,
            status: isCorsError ? 200 : 0
        };
    }
};

// 批量检查 URLs
export const checkUrls = async (urls, onProgress, onStatusUpdate) => {
    const results = {};
    let checked = 0;
    const total = urls.length;

    for (const url of urls) {
        const result = await checkUrl(url);
        results[url] = result;
        
        // 立即通知状态更新
        if (onStatusUpdate) {
            onStatusUpdate(url, result);
        }
        
        checked++;
        if (onProgress) {
            onProgress(checked, total);
        }
    }

    return results;
}; 